<script lang="ts">
	// Navigation items type
	type NavItem = {
		title: string;
		href: string;
	};

	// Navigation items
	const navItems: NavItem[] = [
			{ title: 'Services', href: '/services' },
			{ title: 'Projects', href: '/projects' },
			{ title: 'About', href: '/about' },
				{ title: 'Contact', href: '/contact' }
	];
</script>

<header
	class="sticky top-0 z-50 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 border-b"
>
	<div class="container flex h-14 md:h-20 items-center justify-between +++pl-6 md:pl-12+++">
		<!-- Logo/Home link -->
		<a href="/" class="flex items-center">
			<img
				src="/logo_light_version.svg"
				alt="thinkfox.ai logo"
				width="508"
				height="128"
				class="h-8 md:h-10 w-auto transition-opacity duration-200"
			/>
		</a>

		<!-- Navigation -->
		<nav class="flex gap-4 md:gap-8">
			{#each navItems as item}
				<a
					href={item.href}
					class="text-sm md:text-base font-medium text-muted-foreground hover:text-primary transition-colors"
				>
					{item.title}
				</a>
			{/each}
		</nav>
	</div>
	<div class="skip-to-content">
		<a href="#main" class="sr-only focus:not-sr-only focus:absolute focus:p-4">
			Skip to main content
		</a>
	</div>
</header>
